import { firebase } from "./app";
import "firebase/firestore";

export const db = firebase.firestore();
